export default "__VITE_PUBLIC_ASSET__019b4f8e__"